export default __webpack_public_path__ + "static/media/62-min.78311c40.jpg";